<template>
  <div class="flex">
    <el-radio v-model="value" @change="handler(index)" :label="data.label" :class="[currIndex===index?'curr':'']"
              v-for="(data,index) in list" :disabled="disabled" :key="index">{{ data.label }}
    </el-radio>
    <!--<el-radio v-model="radio" label="2">备选项</el-radio>-->
    <!--<ul class="radius flex0 flex">-->
    <!--<li class="fs14 color_333 pl15 pr15 pointer" @click="handler(index)" :class="[currIndex===index?'curr':'']"-->
    <!--v-for="(data,index) in list">-->
    <!--{{data.label}}<span class="el-icon-check"></span>-->
    <!--</li>-->
    <!--</ul>-->
  </div>
</template>
<style scoped lang="scss">
@import "../../styles/var";

div {
  height: 36px;
  line-height: 36px;
}

li {
  border: 1px solid $bgColor;

  span {
    display: none;
  }

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0px 4px 4px 0px;
  }

  &.curr {
    border: 1px solid $mainColor;
    color: $mainColor;
    background-color: $bgPrimaryColor;

    span {
      display: inline;
    }
  }
}

.curr + li {
  border-left: 1px solid $mainColor;
}

li + li {
  margin-left: -1px;
}
</style>
<script>
import {isEmpty} from "../../lib/utils";

export default {
  name: "v-radio-group",
  props: {
    value: [String, Number],
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currIndex: null
    }
  },

  created() {
    this.setIndex();
  },

  watch: {
    value() {
      this.setIndex();
    }
  },

  methods: {
    setIndex() {
      if (!isEmpty(this.value)) {
        this.currIndex = this.list.findIndex(r => r.value === this.value);
      }
    },


    handler(index) {
      this.currIndex = index;
      this.$emit('change', this.list[index]);
    }
  },

}
</script>
